<template>
    <span :class="'status status-'+status">{{ status }}</span>
</template>
<script>
export default {
    props: {
        status: {
            type: String,
            required: true,
        }
    }
}
</script>
<style lang="scss" scoped>
.status {
    padding: 3px;
    border-radius: 3px;
    background: #666;
    color: white;

    &-Pending {
        background: rgb(255, 183, 88);
    }
    &-Approved {
        background: rgb(110, 218, 61);
    }
    &-Declined {
        background: red;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/CalendarEventStatus.vue